import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useQuizQuestion(data = {}) {
  const {
    enabled = false,
    queryParams = '',
    quizID,
    courseID,
    chapterID,
    questionID,
    configs = {},
  } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getQuizQuestion() {
    return privateFetch
      .get(
        `/v1/admin/course/${courseID}/chapters/${chapterID}/quizzes/${quizID}/questions/${questionID}${queryParams}`,
        configs
      )
      .then((res) => res.data);
  }

  return useQuery(['quiz-single-question', questionID, { data }], getQuizQuestion, { enabled });
}

export default useQuizQuestion;
